import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../authContext';

function Header() {
  const { role } = useAuth();
  const location = useLocation();

  // Tabs für alle Benutzer (ohne Dashboard)
  const publicTabs = [    
    { id: 'tasks', label: 'Aufgaben', path: '/tasks' },
    { id: 'companies', label: 'Unternehmen', path: '/companies' },
    { id: 'contacts', label: 'Ansprechpartner', path: '/contacts' },
  ];

  // Tabs nur für Admins
  const adminTabs = [
    { id: 'users', label: 'Benutzer', path: '/users' },
    { id: 'logs', label: 'Protokoll', path: '/logs' },
  ];

  // Synchronisiere activeTab mit der aktuellen URL
  const getActiveTab = () => {
    const path = location.pathname;
    const publicTab = publicTabs.find(tab => path.startsWith(tab.path));
    if (publicTab) return publicTab.id;
    const adminTab = adminTabs.find(tab => path.startsWith(tab.path));
    if (adminTab) return adminTab.id;
    return 'tasks'; // Fallback auf Aufgaben
  };

  const activeTab = getActiveTab();

  return (
    <div className="header">
      <div className="header-left">
        <div className="header-logo">
          <h1>MeinKleinesCRM</h1>
        </div>
        <div className="tab-navigation">
          {publicTabs.map((tab) => (
            <NavLink
              key={tab.id}
              to={tab.path}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
          {role === 'Admin' && adminTabs.map((tab) => (
            <NavLink
              key={tab.id}
              to={tab.path}
              className={`tab-button admin-only ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Header;